import React from 'react';
import {
    Dialog, DialogTitle, DialogContent, Typography, Box, Divider, Button
} from '@mui/material';

export const TemplateHelpContent: React.FC = () => (
    <Box sx={{ color: '#334155' }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 800, mb: 1, color: '#1e293b' }}>
            基本的なメッセージ送信
        </Typography>
        <Typography variant="body2" sx={{ mb: 2 }}>
            テンプレートを選択すると入力欄に展開されます。そのまま送信、または編集して送信できます。
        </Typography>

        <Divider sx={{ my: 2 }} />

        <Typography variant="subtitle1" sx={{ fontWeight: 800, mb: 1, color: '#1e293b' }}>
            変数の利用
        </Typography>
        <Typography variant="body2" sx={{ mb: 1 }}>
            以下の変数が利用可能です。送信時に自動的に顧客の情報に置換されます。
        </Typography>
        <Box component="ul" sx={{ pl: 2, mb: 2, fontSize: '0.875rem' }}>
            <li><code>{'{customer_name}'}</code> : 顧客氏名</li>
            <li><code>{'{id}'}</code> : 予約ID</li>
            <li><code>{'{form}'}</code> : 予約フォームURL</li>
            <li><code>{'{start_date}'}</code> : 出発日時 (2024/03/20 10:00)</li>
            <li><code>{'{end_date}'}</code> : 返却日時 (2024/03/21 16:00)</li>
            <li><code>{'{start_time}'}</code> : 出発時間のみ (10:00)</li>
            <li><code>{'{end_time}'}</code> : 返却時間のみ (16:00)</li>
        </Box>

        <Divider sx={{ my: 2 }} />

        <Typography variant="subtitle1" sx={{ fontWeight: 800, mb: 1, color: '#1e293b' }}>
            条件分岐 (if / elseif / else)
        </Typography>
        <Typography variant="body2" sx={{ mb: 1 }}>
            特定の条件に基づいてメッセージ内容を変えることができます。
        </Typography>
        <Box sx={{ bgcolor: '#f8fafc', p: 1.5, borderRadius: '8px', border: '1px solid #e2e8f0', mb: 2 }}>
            <pre style={{ margin: 0, fontSize: '12px', color: '#475569', whiteSpace: 'pre-wrap' }}>
{`{customer_name}様
{% if id != "" %}
ご予約（ID: {id}）を承っております。
フォームはこちら： {form}
{% elseif car_name != "" %}
お探しの車が見つかりました： {car_name}
{% else %}
お問い合わせありがとうございます。
{% endif %}`}
            </pre>
        </Box>
        <Typography variant="caption" color="text.secondary">
            ※ <code>!= ""</code> は「空でない場合」を意味します。
        </Typography>
    </Box>
);

interface TemplateHelpDialogProps {
  open: boolean;
  onClose: () => void;
}

const TemplateHelpDialog: React.FC<TemplateHelpDialogProps> = ({ open, onClose }) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            sx={{ zIndex: 10600 }}
            PaperProps={{ sx: { borderRadius: '16px' } }}
        >
            <DialogTitle sx={{ fontWeight: 900, fontSize: '1.25rem', borderBottom: '1px solid #f1f5f9' }}>
                テンプレート・チュートリアル
            </DialogTitle>
            <DialogContent sx={{ mt: 2 }}>
                <TemplateHelpContent />
            </DialogContent>
            <Box sx={{ p: 2, display: 'flex', justifyContent: 'flex-end', borderTop: '1px solid #f1f5f9' }}>
                <Button onClick={onClose} variant="contained" sx={{ borderRadius: '8px', fontWeight: 800 }}>
                    閉じる
                </Button>
            </Box>
        </Dialog>
    );
};

export default TemplateHelpDialog;
